import {
  calculatePartialDateDifferenceInMonths,
  nowPartialDate,
  parsePatientDemographics,
  partialDateFromDate,
} from 'neuro-utils';
import { getStore } from 'Store/storeRef';

/**
 * Calculate how old the patient is in months, or calculate how old they were based on comparison date
 * @param atThisDate calculate months compared to this date
 * @param floorValue remove decimals
 * @param patientData use this ssn and ssn localization instead to calculate age
 * @returns number of months based on when the patient is born
 */
export const getPatientAgeInMonths = (
  atThisDate: PartialDate | null | undefined,
  floorValue?: boolean,
  patientData?: { ssn: string; ssnLocalization: PatientCountryCode },
) => {
  const { ssn, ssnLocalization } = patientData ?? getStore().getState().patient.data ?? {};
  const ssnBirthdayDate =
    ssn && ssnLocalization
      ? parsePatientDemographics(ssnLocalization, {
          ssn,
        })?.dateOfBirth
      : undefined;
  if (!ssnBirthdayDate) return 0;
  const bdDate = partialDateFromDate(new Date(ssnBirthdayDate));
  const compareDate = atThisDate ?? nowPartialDate();
  return floorValue
    ? Math.floor(calculatePartialDateDifferenceInMonths(bdDate, compareDate))
    : calculatePartialDateDifferenceInMonths(bdDate, compareDate);
};

/**
 * Calculates the age of the patient in months with the precision of one decimal
 * @param atThisDate Age calculated atThisDate, if omitted at current day
 * @return String containing Age as number of months
 */
export const getPatientAgeInMonthsWithOneDecimal = (atThisDate: PartialDate | undefined | null): string => {
  return getPatientAgeInMonths(atThisDate).toFixed(1);
};
